import * as React from "react";
import {useEffect, useState} from "react";
import api from "../../../utils/api";
import reservationStore from "../../../store/reservationStore";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import PhoneInTalkRoundedIcon from '@mui/icons-material/PhoneInTalkRounded';
import * as util from "../../../utils/util";
import img01 from "../../../assets/images/img01.jpg";
import CircularProgress from "@mui/material/CircularProgress";
// @ts-ignore
import InfiniteScroll from "react-infinite-scroller";

const hospitalParam = {
  cusId: '',
  famId: '',
  pageNum: 0,
  region: '',
  searchWord: ''
}

const SetHospital = (props: any) => {
  const storeData: any = reservationStore();
  const [hospitals, setHospitals] = useState([]); // 예약 가능한 병원
  const [regionList, setRegionList] = useState([]); // 병원 지역 목록
  const [selectedRegion, setSelectedRegion] = useState('all'); // 병원 지역 검색
  const [selectedWord, setSelectedWord] = useState(''); // 병원명 검색
  const [loading, setLoading] = React.useState(true);
  // 조회 실패 상태. 예전에는 catch 가 console.log 뿐이라 하단 스피너가 영영 돌고
  // '예약 가능한 병원이 없습니다' 도 뜨지 않아, 사용자는 계속 기다리게 됐다.
  const [failed, setFailed] = React.useState(false);
  const isRef = React.useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);

    return () => {
      storeData.setReservationInfo('date', '');
      storeData.setReservationInfo('time', '');
      storeData.setCloseItems([]);
      storeData.setReservationInfo('pkgId', '');
      storeData.setReservationInfo('addPrice', 0);
      storeData.setCheckedInjectioList([]);
      storeData.setChoiceLimitCount(0);
    }
  }, []);
  
  async function getHospitals(page :any) {
    try {
      setTimeout(() => {
        hospitalParam.cusId = localStorage.getItem('userCusID') || '';
        hospitalParam.famId = decodeURIComponent(storeData.reservationInfo.famId);
        hospitalParam.pageNum = page-1;
        hospitalParam.region = selectedRegion;
        hospitalParam.searchWord = selectedWord;
        
        api.post(`customer/api/v1/CU_003_002_1`, hospitalParam).then(res => {
          if(res.data.hospitalList.length < 1){
            setLoading(false);
            return false;
          }
          setRegionList(res.data.regionList);
          setHospitals((prev) => prev.concat(res.data.hospitalList));
        }).catch(function (error) {
          console.log(error);
          // 실패해도 스피너는 반드시 걷는다
          setLoading(false);
          setFailed(true);
        });
      }, page-1 === 0 ? 0 : 1000);
    } catch (error) {}
  }
  
  
  async function handleSearchHospital(page :any) {
    setLoading(true);
    setFailed(false);
    setHospitals([]);
    // @ts-ignore
    isRef.current.pageLoaded = 0;
  }

  // 홈페이지 바로가기 버튼 활성화
  function hospitalCardUrlEnter(url: string) {
    if (!url.match(/^http?:\/\//i) || !url.match(/^https?:\/\//i)) {
      url = 'http://' + url;
    }
    window.open(url);
  }

  // 병원 선택 => 예약정보에 병원아이디 설정, 다음 스텝으로 이동
  function selectReservationHospital(hosId: string, target: any) {
    // target.closest('li').style.color = 'red';
    storeData.setReservationInfo('hosId', hosId);
    props.handleNext();
  }

  const handleChangeByRegion = (e: any) => {
    setSelectedRegion(e.target.value);
  };

  const handleChangeByWord = (e: any) => {
    setSelectedWord(e.target.value);
  };



  return (

    <Container maxWidth="xl" sx={{ p:'0 20px 70px 20px' }}>
      {/*<Box sx={{ bgcolor: '#FFFBF8', height: '100px',}} >
        <Stack direction="row"  spacing={1} sx={ChipStyle}>
          <Chip label="대전 유성구" onClick={handleClick} className="chipOn"/>
          <Chip label="거리순"  onClick={handleClick} />
          <Chip label="종합검진" onClick={handleClick} />
          <Chip label="최저가" variant="outlined" onClick={handleClick} />
          <Chip label="국가검진" variant="outlined" onClick={handleClick} />
          <Chip label="건강검진" variant="outlined" onClick={handleClick} />
          <Chip label="1515건강검진" variant="outlined" onClick={handleClick} />
        </Stack>

        <Typography sx={{ display: 'flex', fontSize:'14px', m:1 }}>
          병원검색
        </Typography>
      </Box>*/}

      <Paper component="form" sx={search_Fome_Style}>
        <Box sx={{ minWidth: 100, borderRight:'1px solid #ddd'}}>
          <FormControl fullWidth sx={{
            '& .MuiOutlinedInput-notchedOutline': { border:'none'}
          }}>
           {/*  <InputLabel id="demo-simple-select-label">지역</InputLabel> */}
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="지역"
              defaultValue="all"
              onChange={handleChangeByRegion}
              sx={{border:'none'}}
            >
              <MenuItem value="all">전체</MenuItem>
              {regionList.map((rg: any, index: any) => (
                <MenuItem key={rg ?? index} value={rg}>{rg}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        <InputBase
          sx={{ ml: 1, flex: 1,}}
          placeholder="병원명을 입력하세요(2자 이상)"
          inputProps={{ 'aria-label': '병원명을 입력하세요' }}
          onChange={handleChangeByWord}
        />
        <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
          <SearchIcon onClick={handleSearchHospital} />
        </IconButton>
      </Paper>

      <Box sx={{}}>
        <List sx={{ width: '100%',  m: '10px auto' }}>
            <InfiniteScroll
              ref={isRef}
              loadMore={getHospitals}
              hasMore={true}
              loader={
                // react-infinite-scroller 는 loader 를 자식 배열에 넣으므로 key 가 필요하다
                <Box key="counsel-hospital-loader" sx={{ display: loading ? 'flex' : 'none', textAlign: 'center'}} justifyContent='center' alignContent={'center'}>
                  <CircularProgress />
                </Box>
              }
            >

              {hospitals.length > 0 ? (
                hospitals && hospitals.map((hospital, index) => (
                  <ListItem key={index} alignItems="flex-start" sx={Card_Style} >
                    <ListItemAvatar>
                      <Avatar alt="" src={util.strNull(hospital['hosImage']) !== '' ? hospital['hosImage'] : img01} sx={{ width: 80, height: 80, borderRadius: 3}}
                        // onClick={() => hospitalCardUrlEnter(hospital['hosURL'])} 
                        onClick={(e) => selectReservationHospital(hospital['hosId'], e.target)}
                        />
                    </ListItemAvatar>
                    <ListItemText sx={{ pl: 2 }}
                      primary={hospital['hosName']}
                      onClick={(e) => selectReservationHospital(hospital['hosId'], e.target)}
                      secondary={
                        <React.Fragment>
                          <Typography
                            sx={{ display: 'inline', }}
                            component="span"
                            variant="body2"
                            color="text.primary"
                          >
                            {hospital['hosAddress']}
                          </Typography>
                          <Typography
                            sx={{ display: 'inline' }}
                            component="span"
                            variant="body2"
                            color="text.primary"
                          >
                          </Typography>
                          <Stack direction="row" spacing={1} sx={CardChipStyle}>
                            {/* <Chip icon={<StarRoundedIcon sx={{color:'#fbb001 !important'}} />}  label={hospital['totalPoint'] } size="small" sx={{bgcolor:'#fff'}} /> */}
                            <Chip icon={<PhoneInTalkRoundedIcon sx={{color:'#888 !important'}} />}  label={hospital['hosPhone']} size="small" sx={{bgcolor:'#fff'}} /> 
                          </Stack>
                        </React.Fragment>
                      }
                    />
                  </ListItem>
                ))
              ) : (
                failed ? (
                  // 결과가 없는 것과 불러오지 못한 것은 다르다 — 구분해서 알린다
                  <Stack key="hospital-failed" alignItems={'center'} sx={{ p: 2 }} spacing={1}>
                    <Typography sx={{ fontSize: 15, color: '#888' }}>병원 목록을 불러오지 못했습니다.</Typography>
                    <Button onClick={() => handleSearchHospital(1)} sx={{ color: '#EF8322', fontSize: 15, fontWeight: 700 }}>
                      다시 시도
                    </Button>
                  </Stack>
                ) : (
                  <Typography sx={{ display: loading ? 'none' : 'block', fontSize: 16, textAlign: 'center', p: 1, color: '#EF8322', fontWeight: 500 }}>예약 가능한 병원이 없습니다.</Typography>
                )
              )}
            
            </InfiniteScroll>
        </List>
      </Box>
    </Container>
  );
}

const search_Fome_Style = {
  m: '30px auto 20px auto',
  p: '2px 4px',
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  borderRadius: '20px',
  boxShadow: 'inset 0 0 4px rgba(0,0,0,0.4)',
  boxSizing: 'border-box'
};

const Card_Style = {
  borderRadius: '20px',
  background: '#fff',
  boxShadow: '0 0 6px  rgba(0,0,0,0.2)',
  marginBottom: '20px'
};

const ChipStyle = {
  maxWidth: 460,
  overflow: 'auto',
  whiteSpace: 'nowrap',
  p: 2
};

const CardChipStyle = {
  maxWidth: 460,
  overflow: 'auto',
  whiteSpace: 'nowrap',
  p: 1,
  pl: 0
};

export default SetHospital;

